<template>
  <div class="deletable-item-wrap">
    <div
      v-if="isDeleted && hasContentSlot"
      v-tooltip="tooltipContent"
      class="deletable-item is-deleted"
    >
      <!-- Alternative display with a tag -->
      <span v-if="showIcon" class="icon trash-icon">
        <i class="fa-solid fa-trash-can fa-xs" />
      </span>
      <slot :is-deleted="isDeleted" />
    </div>
    <slot v-else :is-deleted="isDeleted" />
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'DeletableItem',
  props: {
    value: { type: [Object, Array, String, Number] },
    showIcon: { type: Boolean, default: true },
  },
  setup(props, { slots }) {
    const hasContentSlot = slots.default !== undefined

    const hasDeletedKey = computed(
      () =>
        props.value &&
        Object.prototype.hasOwnProperty.call(props.value, 'deleted'),
    )
    const isDeleted = computed(() => props.value?.deleted === true)

    const tooltipContent = computed(() => {
      let baseName = props.value?.label || props.value?.name
      if (baseName)
        baseName = `<code class="has-text-danger">${baseName}</code>`
      else baseName = 'This item'
      return `${baseName} has been deleted`
    })
    return { hasDeletedKey, isDeleted, hasContentSlot, tooltipContent }
  },
}
</script>

<style lang="scss" scoped>
.deletable-item-wrap {
  display: contents;
}

.deletable-item {
  display: inline-flex;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  flex-wrap: nowrap;

  *:not(:is(.icon, i)) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .icon:first-child:not(:last-child) {
    margin-left: 0;
  }
}

.deletable-item.is-deleted {
  --mixed-danger-color: var(--danger-muted);

  color: var(--mixed-danger-color);
  text-decoration-color: var(--mixed-danger-color);
  cursor: default;

  :deep(*) {
    color: var(--mixed-danger-color);
    text-decoration-color: var(--mixed-danger-color);
  }

  & > *:not(:hover):not(.trash-icon) {
    text-decoration: line-through;
    text-decoration-thickness: 0.5px;
  }

  :deep(a) {
    color: var(--mixed-danger-color);

    &:hover {
      color: var(--danger);
      text-decoration: underline;
      text-underline-offset: 5px;
      cursor: pointer;
    }
  }
}

.trash-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.35rem;
  min-width: 24px;
}
</style>
